export const notificationKeys = {
  list: () => ['notifications'] as const,
}
